import React, {useEffect, useState} from 'react';
import HeaderComponent from "../../component/base/header-component/HeaderComponent";
import FooterComponent from "../../component/base/footer-component/FooterComponent";
import LoginWithUsernamePasscode from '../LoginOtherPage/LoginWithUsernamePasscode';
import LoginWithPromotionCode from './LoginWithPromotionCode';
import OnboardSlider from "../../component/base/onboard-slider-component/OnboardSlider";
import OnboardButton from "../../component/base/onboard-button-component/OnboardButton";
import OnboardTabs from "../../component/base/onboard-tabs-component/OnboardTabs";
import option1 from 'assets/images/login/login-option-5.svg';
import option2 from 'assets/images/login/login-option-4.svg';

const LoginOtherPage = (props) => {
    const {t, navigate, handleInformation} = props.props;

    const [visibleTabs, setVisibleTabs] = useState(1);
    const handleChangeTab = (tab) => {
        setVisibleTabs(tab);
        if (location.pathname !== "/simulation")
            if (tab === 1)
                handleInformation("login_type_4");
            else if (tab === 2)
                handleInformation("login_type_6");
    }

    useEffect(() => {
        if (location.pathname !== "/simulation")
            handleInformation("login_type_4");
    }, [])

    return (
        <div>
            <HeaderComponent title={t('login.title')}
                             content={visibleTabs === 1 ? t('login.content_gift_coupon_code') : t('login.content_username_password')}/>

            <div className="content-root top">

                <p className="login-options">{t('login.enter_options')}</p>

                <OnboardTabs onChange={(e) => handleChangeTab(e)}
                             defaultActiveTab={visibleTabs}
                             tabs={[
                                 {key: 1, label: t('login.tabs.option_gift_coupon_code'), icon: option1},
                                 {key: 2, label: t('login.tabs.option_username'), icon: option2},
                             ]}
                />

                <div className="login-input-area">

                    {visibleTabs === 1 && (<div>
                        <p className="login-inner-title">{t('login.tabs.gift_coupon_code')}</p>
                        <LoginWithPromotionCode props={props.props}/>
                    </div>)}

                    {visibleTabs === 2 && (<div>
                        <p className="login-inner-title">{t('login.tabs.username_password')}</p>
                        <LoginWithUsernamePasscode props={props.props}/>
                    </div>)}

                </div>

                <div className="h-12"/>

                <OnboardButton gray label={t('login.miles_and_smiles_with_login')}
                               onClick={() => navigate("/login")}/>

                <OnboardSlider/>

            </div>

            <FooterComponent/>

        </div>

    );
};

export default LoginOtherPage;

